import React from 'react';

const BlacklistItemCategoryHeader = ({ title }) => <div className="category-header">{title}</div>;


export default BlacklistItemCategoryHeader;
